import React, { useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { PLStatement } from '../../models/PLStatement';
import './ProfitLossStatement.scss';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import PLStatementMktLvl from './PLStatementMktLvl';
import Modal from '../Modal/Modal';
import { Collapse, IconButton } from '@material-ui/core';
import moment, { Moment } from 'moment';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

type PLProps = {
  items: any;
  langData: any;
  startDate: Moment;
  endDate: Moment;
  searchName: string;
};

const ProfitLossStatement: React.FC<PLProps> = (props) => {
  // const { items, isUserPLStatement } = props;
  const { items, startDate, endDate, searchName, langData } = props;
  const [selectedRecord, setSelectedRecord] = useState<PLStatement>();
  const [open, setOpen] = useState<any>(false);

  return (
    <div className="pl-stmt-tbl tbl-ctn">
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className="game-type-col" align="left">
                {langData?.['game']}
              </TableCell>
              <TableCell className="bwon-col" align="left">
                {langData?.['won']}
              </TableCell>
              <TableCell className="blost-col" align="left">
                {langData?.['lost']}
              </TableCell>
              <TableCell className="pandl-col" align="left">
                {langData?.['profit_loss']}
              </TableCell>
            </TableRow>
          </TableHead>

          {items && items.size > 0 ? (
            <>
              {[...items.keys()]
                .sort((a, b) => (a < b ? 1 : -1))
                .map((key) => (
                  <>
                    {items.get(key).length > 0 ? (
                      <TableBody className="tbl-body">
                        {items?.get(key)?.map((row) => (
                            <>
                              <TableRow
                                className="myb-table-row"
                                key={
                                  'key_' +
                                  Math.random().toString(36).substr(2, 9)
                                }
                                onClick={() => {
                                  setSelectedRecord(row);
                                }}
                              >
                                <TableCell
                                  className="myb-table-cell game-type-col"
                                  align="left"
                                  onClick={() =>
                                    setOpen((prevState) => {
                                      return {
                                        ...prevState,
                                        [moment(key, 'DD-MM-YYYY').format(
                                          'DD/MM/YYYY'
                                        ) +
                                        '-' +
                                        row?.eventId +
                                        '-' +
                                        row?.marketId]: prevState[
                                          moment(key, 'DD-MM-YYYY').format(
                                            'DD/MM/YYYY'
                                          ) +
                                            '-' +
                                            row?.eventId +
                                            '-' +
                                            row?.marketId
                                        ]
                                          ? false
                                          : true,
                                      };
                                    })
                                  }
                                >
                                  <span className="txt-bldin-mob">
                                    {row.eventName
                                      ? row.eventName
                                      : row.gameType}
                                    {row.marketName
                                      ? ' - ' + row.marketName
                                      : null}
                                  </span>
                                </TableCell>
                                <TableCell
                                  className="myb-table-cell bwon-col"
                                  align="left"
                                >
                                  <span className="txt-bldin-mob">
                                    {row.gamesWon}
                                  </span>
                                </TableCell>
                                <TableCell
                                  className="myb-table-cell blost-col"
                                  align="left"
                                >
                                  <span className="txt-bldin-mob">
                                    {row.gamesLost}
                                  </span>
                                </TableCell>
                                <TableCell align="left" className="pandl-col">
                                  <span className="txt-bldin-mob">
                                    {row.profit > 0 ? (
                                      <div className="profit">
                                        {Number(row.profit).toFixed(2)}
                                      </div>
                                    ) : row.profit < 0 ? (
                                      <div className="loss">
                                        {Number(row.profit).toFixed(2)}
                                      </div>
                                    ) : (
                                      <>{Number(row.profit).toFixed(2)}</>
                                    )}
                                  </span>
                                </TableCell>
                                <TableCell>
                                  <IconButton
                                    aria-label="expand row"
                                    size="small"
                                    onClick={() =>
                                      setOpen((prevState) => {
                                        return {
                                          ...prevState,
                                          [moment(key, 'DD-MM-YYYY').format(
                                            'DD/MM/YYYY'
                                          ) +
                                          '-' +
                                          row?.eventId +
                                          '-' +
                                          row?.marketId]: prevState[
                                            moment(key, 'DD-MM-YYYY').format(
                                              'DD/MM/YYYY'
                                            ) +
                                              '-' +
                                              row?.eventId +
                                              '-' +
                                              row?.marketId
                                          ]
                                            ? false
                                            : true,
                                        };
                                      })
                                    }
                                  >
                                    {open[
                                      moment(key, 'DD-MM-YYYY').format(
                                        'DD/MM/YYYY'
                                      ) +
                                        '-' +
                                        row?.eventId +
                                        '-' +
                                        row?.marketId
                                    ] ? (
                                      <KeyboardArrowUpIcon htmlColor={'#000'} />
                                    ) : (
                                      <KeyboardArrowDownIcon
                                        htmlColor={'#000'}
                                      />
                                    )}
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  style={{ paddingBottom: 0, paddingTop: 0 }}
                                  colSpan={6}
                                >
                                  <Collapse
                                    in={
                                      open[
                                        moment(key, 'DD-MM-YYYY').format(
                                          'DD/MM/YYYY'
                                        ) +
                                          '-' +
                                          row?.eventId +
                                          '-' +
                                          row?.marketId
                                      ]
                                        ? true
                                        : false
                                    }
                                    timeout="auto"
                                    unmountOnExit
                                    className="Collapse-list"
                                  >
                                    <Modal
                                      open={open}
                                      title="Profit Loss Details"
                                      customClass="light-bg-title"
                                      closeHandler={() => setOpen(false)}
                                      size="md"
                                    >
                                      <PLStatementMktLvl
                                        selectedMarket={selectedRecord}
                                        startDate={startDate}
                                        endDate={endDate}
                                        showGameLevel={() => {
                                          setSelectedRecord(null);
                                        }}
                                        searchName={searchName}
                                      />
                                    </Modal>
                                  </Collapse>{' '}
                                </TableCell>{' '}
                              </TableRow>
                            </>
                          ))}
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell
                            className="no-data-cell"
                            variant="body"
                            colSpan={5}
                          >
                            {langData?.['profit_loss_found']}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </>
                ))}
            </>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell className="no-data-cell" variant="body" colSpan={5}>
                  {langData?.['profit_loss_found']}
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    langData: state.common.langData,
  };
};

export default connect(mapStateToProps)(ProfitLossStatement);
